import { createContext, useContext } from 'react';
export const ProductDeleteModalContext = /*#__PURE__*/createContext({
  isDeleteModalOpen: false,
  setIsDeleteModalOpen: () => {}
});
export const useProductDeleteModal = () => {
  const context = useContext(ProductDeleteModalContext);
  if (context === undefined) {
    throw new Error('ProductDeleteModalContext data is undefined. useProductDeleteModal must be used within a ProductDeleteModalContext.Provider');
  }
  return context;
};